import api from "./api";

export default class MuralApi {
  static getImages = async () => {
    const response = await api.get(`/Mural?Page=${1}&RecordsPerPage=${1000}`);
    return response.data;
  };
}
